import { css } from "@emotion/react"
import { PHOTO_LIST_RESOURCE_URL } from "config"
import { MouseEvent } from "react"
import { PhotoWithIndex } from "type"

type Props = {
  photo: PhotoWithIndex
  onClick?: (event: MouseEvent<HTMLImageElement>, index: number) =>void
}


export const ImageItem = (props: Props)=>{

  const onRawClick = (event: MouseEvent<HTMLImageElement>) =>{
    if (props.onClick === undefined){
      return
    }
    props.onClick(event, props.photo.index)
  }

  return(
    <img
      loading="lazy"
      css={imgCss}
      src={PHOTO_LIST_RESOURCE_URL+'/'+props.photo.filename}
      onClick={onRawClick}
      alt="uploaded"
    />
  )
}

const imgCss = css`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`